import {IActionFn, IPageData} from '@/store/types';
import {IModuleState} from './types';
import {$http} from '@/axios';
import store from '@/store';

// 查询展示列表
export const queryDpsPage: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDpsPage', {...state.dpsPage, loading: true});
        const res: IPageData = await $http.post('/design/project/show/list/platform', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setDpsPage', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setDpsPage', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 查询展示内容列表
export const queryDpscPage: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setDpscPage', {...state.dpscPage, loading: true});
        const res: IPageData = await $http.post('/design/project/show/content/list/platform', payload);
        const {list: data, pageNum, pageSize, total} = res;
        commit('setDpscPage', {data, pageNum, pageSize, total});
    } catch (e) {
        commit('setDpscPage', {data: [], pageNum: 0, pageSize: 0, total: 0});
    }
};

// 删除展示
export const deleteDps: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/design/project/show/delete/platform', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 保存展示（样板间专用，自动添加 showType=1）
export const saveDps: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLoading', true);
        const form = new FormData();
        const file = payload.file;
        delete payload.file;

        // 关键：为样板间展示添加 showType=1
        const dataWithShowType = {
            ...payload,
            showType: 1,
        };

        form.append('command', new Blob([JSON.stringify(dataWithShowType)], {type: 'application/json'}));
        form.append('file', file);
        await $http.post('/design/project/show/save/platform', form);
    } finally {
        commit('setLoading', false);
    }
};

// 删除展示内容
export const deleteDpsc: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setConfirm', {...state.confirm, loading: true});
        await $http.post('/design/project/show/content/delete/platform', payload);
    } finally {
        commit('setConfirm', {visible: false});
    }
};

// 保存展示内容
export const saveDpsc: IActionFn<IModuleState> = async ({commit, state}, payload) => {
    try {
        commit('setLoading', true);
        const file = payload.file;
        delete payload.file;
        const form = new FormData();
        form.append('command', new Blob([JSON.stringify(payload)], {type: 'application/json'}));
        form.append('file', file);
        await $http.post('/design/project/show/content/save/platform', form);
    } finally {
        commit('setLoading', false);
    }
};

// 校验展示是否支持移动端可进入
export const validateMobileAccessible: IActionFn<IModuleState> = async (_, showCode) => {
    try {
        const res = await $http.get(`/v1/admin/design/show/${showCode}/mobile-accessible/validate`);
        return res;
    } catch (e) {
        return {valid: false, nonSupportItems: [], message: '校验失败'};
    }
};

// 更新展示的移动端可进入状态
export const updateMobileAccessible: IActionFn<IModuleState> = async (_, payload) => {
    try {
        await $http.put('/v1/admin/design/show/mobile-accessible', payload);
        store.commit('common/setToast', {visible: true, text: '更新成功'});
        return true;
    } catch (e) {
        const errorMsg = (e as any)?.message || '更新失败';
        store.commit('common/setToast', {visible: true, text: errorMsg});
        return false;
    }
};
